var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.1 490.1",
    style: {
      enableBackground: "new 0 0 490.1 490.1"
    },
    fill: "#ffffffcc",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245,261.8c71.9,0,131.4-57.3,131.4-130.3S316.9,0.1,245,0.1S113.6,57.3,113.6,130.4S173.1,261.8,245,261.8z M245,40.8 c50,0,90.7,40.7,90.7,89.7S295,220,245,220s-90.7-40.7-90.7-89.7S195,40.8,245,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6,274.2c-8.3-2.1-16.7,0-21.9,6.3L245,356.6l-66.7-76.1c-5.2-6.3-14.6-8.3-21.9-6.3C61.5,305.5,0,382.6,0,469.1 C0,480.6,9.4,490,20.9,490h448.3c11.5,0,20.9-9.4,20.9-20.9C490,382.6,428.5,305.5,333.6,274.2z M42.7,449.4 C51.1,392.1,92.8,343,157.4,318l73,83.4c7.3,9.4,22.9,9.4,30.2,0l73-83.4c63.6,25,106.4,75,114.7,131.3L42.7,449.4L42.7,449.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8f1ef065cdacae9fe4635fb06849890f.svg";
export { ForwardRef as ReactComponent };